import getters from './getters';
import mutations from './mutations';
import {AddFundsState} from '@/modules/add-funds/store/types';

const state: AddFundsState = {
    open: false,
};

export const addFunds = {
    state,
    getters,
    mutations,
};
